import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import '../App.css';

class BasicDetails extends Component {
  state = {
    name: '',
    email: '',
    pin: '',
    work: '',
    age: '',
    otherWork: '',
  };

  handleRadio = (event) => {
    if (event.target.name === 'work') {
      this.setState({ work: event.target.value });
    } else if (event.target.name === 'age') {
      this.setState({ age: event.target.value });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.otherWork !== '') {
      this.setState({ work: `${this.state.otherWork}` });
    }
    this.props.StateStore.addBasicDetails(
      this.state.name,
      this.state.email,
      this.state.pin,
      this.state.work,
      this.state.age
    );
    this.props.StateStore.changeRoute('questions');
  };
  render() {
    return (
      <div className='container-fluid'>
        <form onSubmit={this.handleSubmit}>
          <div className='eachQuestion'>
            <h2>What is your Name?</h2>
            <input
              type='text'
              className='textbox'
              placeholder='Enter Your Name'
              value={this.state.name}
              onChange={(event) => {
                this.setState({ name: event.target.value });
              }}
              required
            />
          </div>
          <div className='eachQuestion'>
            <h2>Please Enter Your Email</h2>
            <input
              type='email'
              className='textbox'
              placeholder='Enter Your Email'
              value={this.state.email}
              onChange={(event) => this.setState({ email: event.target.value })}
              required
            />
          </div>
          <div className='eachQuestion'>
            <h2>Enter Pin-code of your Residence in Odisha</h2>
            <input
              type='text'
              className='textbox'
              placeholder='Enter Your Pin Code'
              value={this.state.pin}
              onChange={(event) => this.setState({ pin: event.target.value })}
              required
            />
          </div>
          <div className='eachQuestion'>
            <h2>How would you identify yourself?</h2>
            <div className='options'>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Professional (salaried employee)'
                  checked={
                    this.state.work === 'Professional (salaried employee)'
                  }
                  onChange={this.handleRadio}
                />
                Professional (salaried employee)
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Entrepreneur (self-employed)'
                  checked={this.state.work === 'Entrepreneur (self-employed)'}
                  onChange={this.handleRadio}
                />
                Entrepreneur (self-employed)
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Business Owner'
                  checked={this.state.work === 'Business Owner'}
                  onChange={this.handleRadio}
                />
                Business Owner
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Homemaker'
                  checked={this.state.work === 'Homemaker'}
                  onChange={this.handleRadio}
                />
                Homemaker
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Student (College/ School)'
                  checked={this.state.work === 'Student (College/ School)'}
                  onChange={this.handleRadio}
                />
                Student (College/ School)
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Social Worker (NGOs)'
                  checked={this.state.work === 'Social Worker (NGOs)'}
                  onChange={this.handleRadio}
                />
                Social Worker (NGOs)
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Healthcare worker (Doctor, Nurse, Attendant)'
                  checked={
                    this.state.work ===
                    'Healthcare worker (Doctor, Nurse, Attendant)'
                  }
                  onChange={this.handleRadio}
                />
                Healthcare(Doctor, Nurse, Attendant)
              </label>
              <label>
                <input
                  type='radio'
                  name='work'
                  value='Government employee'
                  checked={this.state.work === 'Government employee'}
                  onChange={this.handleRadio}
                />
                Government employee
              </label>
              <label className='other'>
                {/* <input
                  type='radio'
                  name='work'
                  value='Other'
                  checked={this.state.work === 'Other'}
                  onChange={this.handleRadio}
                /> */}
                Other
                <input
                  type='text'
                  className='textbox'
                  name='work'
                  placeholder='Enter Other If Any'
                  value={this.state.work}
                  onChange={this.handleRadio}
                />
              </label>
            </div>
          </div>
          <div className='eachQuestion'>
            <h2>What is your age?</h2>
            <div className='options'>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='<18'
                  checked={this.state.age === '<18'}
                  onChange={this.handleRadio}
                />
                Less than 18
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='18-25'
                  checked={this.state.age === '18-25'}
                  onChange={this.handleRadio}
                />
                18-25
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='25-30'
                  checked={this.state.age === '25-30'}
                  onChange={this.handleRadio}
                />
                25-30
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='30-40'
                  checked={this.state.age === '30-40'}
                  onChange={this.handleRadio}
                />
                30-40
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='40-50'
                  checked={this.state.age === '40-50'}
                  onChange={this.handleRadio}
                />
                40-50
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='50-60'
                  checked={this.state.age === '50-60'}
                  onChange={this.handleRadio}
                />
                50-60
              </label>
              <label>
                <input
                  type='radio'
                  name='age'
                  value='60+'
                  checked={this.state.age === '60+'}
                  onChange={this.handleRadio}
                />
                60+
              </label>
            </div>
          </div>
          <div className='buttonBox'>
            <button type='submit' className='text-center'>
              Next
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default inject('StateStore')(observer(BasicDetails));
